import { gql } from 'apollo-client-ppc';

export const fetchNativeProductCatalogueWithOfferingAndPricingPlans = gql`
  query fetchNativeProductCatalogueWithOfferingAndPricingPlans(
    $pageParams: ProductPageParams
    $searchText: String
    $pricingPlanFilterOptions: [FilterOption]
    $filterOptions: [FilterOption]
    $includeExperimentalProducts: Boolean
    $isAddOnsSearchEnabled: Boolean
    $isStatuspageEnabled: Boolean
    $isTeamWorkCollectionEnabled: Boolean
    $isStrategyCollectionEnabled: Boolean
    $isBitbucketProductEnabled: Boolean
  ) {
    nativeCatalog: partnerNativeCatalog(
      pageParams: $pageParams
      searchText: $searchText
      filterOptions: $filterOptions
      includeExperimentalProducts: $includeExperimentalProducts
      isAddOnsSearchEnabled: $isAddOnsSearchEnabled
      isStatuspageEnabled: $isStatuspageEnabled
      isTeamWorkCollectionEnabled: $isTeamWorkCollectionEnabled
      isStrategyCollectionEnabled: $isStrategyCollectionEnabled
      isBitbucketProductEnabled: $isBitbucketProductEnabled
    ) {
      nodes {
        id
        name
        productFamily
        productType
        updatedDate
        baseProduct
        addonParentProducts {
          parentName
        }
        updatedDate
        isApp
        isProduct
        isEnabledForOrder
        logoId
        url
        currency
        plans {
          id
          name
          pricingPlanType
          listPrice
          priceUpdated
          periodUnit
        }
        hasOptedInForPartnerPromotion
        vendorName
        offering {
          id
          offeringName
          pricingType
          level
          trialLengthInDays
          offeringGroup
          relationshipRequirements {
            level
            side
            type
          }
          chargeElements {
            type
            data {
              ceiling
            }
          }
          availablePricingPlans(filterOptions: $pricingPlanFilterOptions) {
            type
            billingFrequency
            updatedAt
            id
            currency
            pricingPlanType
            status
            description
            tiers {
              floor
              ceiling
              amount
              unitAmount
              flatAmount
            }
          }
          availableProducts
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
